import React from 'react';
import { createIcon } from './create-icon';
import './icon-filters-active.scss';

export const IconFiltersActive = createIcon(<div className="icon-filters-active" />);
